import { services } from '../services';

const packagesStore = {
  state: {
    packages: undefined,
    lastFetch: undefined,
    lastMemberGuid: '',
  },

  mutations: {
    updatePackages(state, payload) {
      state.packages = payload.packages;
      state.lastFetch = new Date();
      state.lastMemberGuid = payload.memberGuid;
    },
    emptyPackagesCache(state) {
      state.packages = undefined;
      state.lastFetch = undefined;
    },
  },

  actions: {
    async updatePackages(context) {
      const packages = await services.checkout.availablePackages();
      const payload = {};
      payload.packages = packages;
      payload.memberGuid = context.rootState.user.userGuid;
      context.commit('updatePackages', payload);
    },
    async emptyPackages({ commit }) {
      commit('emptyPackagesCache');
    },
  },
};

export { packagesStore };
